module.exports = __webpack_public_path__ + "static/media/cupom_desconto.30462ed0.svg";